module.exports = __webpack_public_path__ + "img/3.3fc1436c.jpg";